module.exports = __webpack_public_path__ + "img/vertical_3_6_5010.d7bae99b.png";